import { useNavigate } from "react-router-dom";
import { RoutedModal } from "../../../../../components/common";
import { PlatformCreditTopup } from "../../../../../components/secondaryComponents/PlatformCredit";

const PlatformCreditTopUp = () => {
  const navigate = useNavigate();

  return (
    <RoutedModal
      isActive={true}
      width={550}
      headerTitle="Top-up Credit"
      closeModal={() => navigate(-1)}
      style={{ height: "auto" }}
    >
      <PlatformCreditTopup />
    </RoutedModal>
  );
};
export default PlatformCreditTopUp;
